import { useQuery } from "@tanstack/react-query";
import { ApiService } from "../services";
import { setConfig } from "../store";

// eslint-disable-next-line import/prefer-default-export
export function useGetStoreConfig(domain, dispatch) {
  return useQuery({
    queryKey: ["store-config", domain],
    queryFn: async () => {
      const response = await ApiService.get(
        `me/store-config?shopDomain=${domain}`
      );

      dispatch(setConfig(response));
      return response;
    },
    staleTime: Infinity,
    enabled: !!domain
  });
}
